/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const RHFTextField = ({ formData, control, isDisabled }) => {


    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        } else if (validation.ValidationType === "Pattern" && validation.ValidationPattern) {
            acc.pattern = {
                value: new RegExp(validation.ValidationPattern),
                message: validation.ValidationMessage || "Invalid input",
            };
        } else if (validation.ValidationType === "Decimal") {
            acc.pattern = {
                value: /^[0-9]+(\.[0-9]+)?$/, // NOSONAR
                message: validation.ValidationMessage || "Please enter a valid decimal number",
            };
        } else if (validation.ValidationType === "Number") {
            acc.pattern = {
                value: /^-?\d+$/, // NOSONAR - Only integers, no decimals
                message: validation.ValidationMessage || "Accept only number",
            };
        } else if (validation.ValidationType === "PositiveNumber") {
            acc.pattern = {
                value: /^\d*\.?\d+$/, // NOSONAR
                message: validation.ValidationMessage || "Accept only positive number",
            };
        }
        return acc;
    }, {});

    // Check if field has Number or PositiveNumber validation
    const hasNumberValidation = formData?.Validations?.some(
        v => v.ValidationType === "Number" || v.ValidationType === "PositiveNumber"
    );
    const hasPositiveNumberValidation = formData?.Validations?.some(
        v => v.ValidationType === "PositiveNumber"
    );
    const hasDecimalValidation = formData?.Validations?.some(
        v => v.ValidationType === "Decimal" || v.ValidationType === "PositiveNumber"
    );
    const isIntegerOnly = formData?.Validations?.some(
        v => v.ValidationType === "Number"
    );

    // Handle key press to prevent invalid input
    const handleKeyDown = (e) => {
        if (!hasNumberValidation) return;

        const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End'
        ];

        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        if (e.ctrlKey || e.metaKey) {
            return;
        }

        // Allow navigation keys
        if (allowedKeys.includes(e.key)) {
            return;
        }

        // Allow decimal point only for Decimal and PositiveNumber types (not for Number type)
        if (e.key === '.' && !isIntegerOnly && hasDecimalValidation && !e.target.value.includes('.')) {
            return;
        }

        // Allow minus sign only for Number validation (not PositiveNumber)
        if (e.key === '-' && !hasPositiveNumberValidation && e.target.selectionStart === 0 && !e.target.value.includes('-')) {
            return;
        }

        // Allow only digits
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };



    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) =>
            (


                <TextField
                    {...field}
                    size="small"
                    label={<>{formData?.LabelName || formData?.DisplayExpr}{(rules?.required || formData?._forceRequired) && (
                        <span style={{ color: isDisabled ? 'inherit' : "red", marginLeft: "2px" }}>*</span>
                    )}</>}
                    variant="outlined"
                    // error={!!error}
                    value={field.value ?? ''}
                    disabled={isDisabled}
                    onKeyDown={handleKeyDown}
                    helperText={
                        error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                    }
                    fullWidth
                    sx={{
                        "& .MuiInputBase-input": {
                            fontSize: "13px",
                        },
                        "& .MuiFormLabel-root": {
                            fontSize: "14px",
                        },
                        "& .MuiOutlinedInput-root": {
                            backgroundColor: formData?.emptyFieldBgColor && !field.value ? formData.emptyFieldBgColor : undefined,
                        },
                    }}
                />


            )
            }
        />
    );
};

export default RHFTextField;
